import { render, staticRenderFns } from "./OrgClosedCasesInPeriod.vue?vue&type=template&id=3f7b7ca0&scoped=true&"
import script from "./OrgClosedCasesInPeriod.vue?vue&type=script&lang=js&"
export * from "./OrgClosedCasesInPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7b7ca0",
  null
  
)

export default component.exports